import { render, staticRenderFns } from "./send-card-stat.vue?vue&type=template&id=068ef2e3&scoped=true&"
import script from "./send-card-stat.vue?vue&type=script&lang=js&"
export * from "./send-card-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ef2e3",
  null
  
)

export default component.exports